import {
  ADD_SERVICE_RECORD,
  ADD_SERVICE_RECORD_FAIL,
  ADD_SERVICE_RECORD_SUCCESS,
  DELETE_SERVICE_RECORD,
  DELETE_SERVICE_RECORD_FAIL,
  DELETE_SERVICE_RECORD_SUCCESS,
  GET_SERVICE_RECORDS,
  GET_SERVICE_RECORDS_FAIL,
  GET_SERVICE_RECORDS_SUCCESS,
  GET_SERVICE_RECORD_LOGS,
  GET_SERVICE_RECORD_LOGS_FAIL,
  GET_SERVICE_RECORD_LOGS_SUCCESS,
  SERVICE_RECORDS_BY_ID,
  SERVICE_RECORDS_BY_ID_FAIL,
  SERVICE_RECORDS_BY_ID_SUCCESS,
  SERVICE_RECORD_ADD_FILE,
  SERVICE_RECORD_ADD_FILE_FAIL,
  SERVICE_RECORD_ADD_FILE_SUCCESS,
  SERVICE_RECORD_DELETE_FILE,
  SERVICE_RECORD_DELETE_FILE_FAIL,
  SERVICE_RECORD_DELETE_FILE_SUCCESS,
  UPDATE_SERVICE_RECORD,
  UPDATE_SERVICE_RECORD_FAIL,
  UPDATE_SERVICE_RECORD_SUCCESS,
} from "./actionType";

export const serviceRecordDeleteFile = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SERVICE_RECORD_DELETE_FILE,
  payload: { data, onSuccess, onError },
});
export const serviceRecordDeleteFileSuccess = data => ({
  type: SERVICE_RECORD_DELETE_FILE_SUCCESS,
  payload: data,
});
export const serviceRecordDeleteFileFail = data => ({
  type: SERVICE_RECORD_DELETE_FILE_FAIL,
  payload: data,
});

export const getServiceLogs = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_SERVICE_RECORD_LOGS,
  payload: { data, onSuccess, onError },
});
export const getServiceLogsSuccess = data => ({
  type: GET_SERVICE_RECORD_LOGS_SUCCESS,
  payload: data,
});
export const getServiceLogsFail = data => ({
  type: GET_SERVICE_RECORD_LOGS_FAIL,
  payload: data,
});

export const serviceRecordAddFile = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SERVICE_RECORD_ADD_FILE,
  payload: { data, onError, onSuccess },
});
export const serviceRecordAddFileSuccess = data => ({
  type: SERVICE_RECORD_ADD_FILE_SUCCESS,
  payload: data,
});
export const serviceRecordAddFileFail = data => ({
  type: SERVICE_RECORD_ADD_FILE_FAIL,
  payload: data,
});

export const serviceRecordById = data => ({
  type: SERVICE_RECORDS_BY_ID,
  payload: data,
});
export const serviceRecordByIdSuccess = data => ({
  type: SERVICE_RECORDS_BY_ID_SUCCESS,
  payload: data,
});
export const serviceRecordByIdFail = data => ({
  type: SERVICE_RECORDS_BY_ID_FAIL,
  payload: data,
});

export const updateServiceRecord = data => ({
  type: UPDATE_SERVICE_RECORD,
  payload: data,
});
export const updateServiceRecordSuccess = data => ({
  type: UPDATE_SERVICE_RECORD_SUCCESS,
  payload: data,
});
export const updateServiceRecordFail = data => ({
  type: UPDATE_SERVICE_RECORD_FAIL,
  payload: data,
});

export const getServiceRecord = data => ({
  type: GET_SERVICE_RECORDS,
  payload: data,
});
export const getServiceRecordSuccess = data => ({
  type: GET_SERVICE_RECORDS_SUCCESS,
  payload: data,
});
export const getServiceRecordFail = data => ({
  type: GET_SERVICE_RECORDS_FAIL,
  payload: data,
});

export const addServiceRecord = data => ({
  type: ADD_SERVICE_RECORD,
  payload: data,
});
export const addServiceRecordSuccess = data => ({
  type: ADD_SERVICE_RECORD_SUCCESS,
  payload: data,
});
export const addServiceRecordFail = data => ({
  type: ADD_SERVICE_RECORD_FAIL,
  payload: data,
});

export const deleteServiceRecord = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_SERVICE_RECORD,
  payload: { data, onError, onSuccess },
});
export const deleteServiceRecordSuccess = data => ({
  type: DELETE_SERVICE_RECORD_SUCCESS,
  payload: data,
});
export const deleteServiceRecordFail = data => ({
  type: DELETE_SERVICE_RECORD_FAIL,
  payload: data,
});
